// Loads the shared Rust→WASM world-gen core (the same artifact proven in
// Spike D) and exposes typed accessors. The client renders the very planet
// the authoritative server would generate — determinism across runtimes.

export interface WorldgenExports {
  sw_planet_hash(u: bigint, g: number, s: number, b: number): bigint;
  sw_planet_radius_km(u: bigint, g: number, s: number, b: number): number;
  sw_planet_archetype(u: bigint, g: number, s: number, b: number): number;
  sw_planet_water_permille(u: bigint, g: number, s: number, b: number): number;
  sw_planet_visual_seed(u: bigint, g: number, s: number, b: number): bigint;
}

export async function loadWorldgen(url = './worldgen.wasm'): Promise<WorldgenExports> {
  // arrayBuffer (not instantiateStreaming) so it works even when the bundled
  // file is served without the application/wasm MIME type inside WKWebView.
  const res = await fetch(url);
  if (!res.ok) throw new Error(`worldgen.wasm fetch failed: ${res.status}`);
  const bytes = await res.arrayBuffer();
  const { instance } = await WebAssembly.instantiate(bytes, {});
  return instance.exports as unknown as WorldgenExports;
}

export const ARCHETYPES = [
  'LushLiving', 'BarrenRock', 'AirlessMoon', 'Desert', 'Ocean', 'Frozen',
  'Volcanic', 'Toxic', 'Irradiated', 'Storm', 'GasGiant', 'Exotic',
] as const;

export const ARCHETYPE_COLORS = [
  0x3fa34d, 0x9c7a54, 0x8a8a8a, 0xd8a24a, 0x2b6fb0, 0xcfe8f5,
  0xc0341d, 0x8fbf3f, 0x6fd66f, 0x6f7fb0, 0xd8b06a, 0xc060d0,
];
